export default {
  en: {
    VIEW_ACTIVITY_TEXT: 'View Activity',
    TITLE_ACTIVITY_FEED: 'Activity Feed for',
    MESSAGE_NO_ACTIVITY: 'No activity.',
    MESSAGE_LOADING_ACTIVITY: 'Loading activity'
  }
};